import { Component as BaseComponent, h } from 'preact';
import { connect } from 'react-redux';
import CatalogProduct from './product';
import { inViewport } from '../../shared/util';
import { MediaQuery as MQ } from '../../shared/media-query';

class Component extends BaseComponent {
    constructor(props) {
        super(props);

        props.filter();

        this.state = {
            page: 1,
            limit: MQ.isMobile() || props.mode == 'journal' ? 8 : 20,
            end: MQ.isMobile() || props.mode == 'journal' ? 8 : 20,
        };
    }

    componentDidMount() {
        if (!this.props.mode || this.props.mode != 'journal') {
            window.addEventListener('scroll', () => {
                if (
                    inViewport('catalog-products row column:last-child')
                    &&
                    this.state.end < this.props.products.length
                ) {
                    const page = this.state.page + 1;
                    const end = (this.state.page * this.state.limit) + this.state.limit;

                    this.setState({
                        page: page,
                        end: end,
                    });
                }
            });
        }
    }

    shouldComponentUpdate(nextProps, nextState) {
        if (nextProps.products != this.props.products) {
            return true;
        }

        if (nextState.page != this.state.page) {
            return true;
        }

        return false;
    }

    render({ products, filters, mode }) {
        if (products && products.length) {
            return (
                <catalog-products mode={mode}>
                    <row className='product-list'>
                        {this.renderProducts()}
                    </row>
                    {this.renderScrollTrigger()}
                </catalog-products>
            );
        } else if (!products && (!filters || !filters.length)) {
            return (
                <catalog-products mode={mode}>
                    <h2>Retrieving products…</h2>
                </catalog-products>
            );
        }

        return (
            <catalog-products mode={mode}>
                <h2>No results found.</h2>
            </catalog-products>
        );
    }

    renderProducts = () => {
        return this.props.products.map((product, i) => {
            if (i < this.state.end) {
                return (
                    <column className='is-3 is-6-mobile has-text-center'>
                        <CatalogProduct product={product} />
                    </column>
                );
            }

            return null;
        });
    }

    renderScrollTrigger = () => {
        if (this.state.end < this.props.products.length && (!this.props.mode || this.props.mode != 'journal')) {
            return (
                <p className='has-text-center scroll-trigger'>
                    {this.state.end} / {this.props.products.length}
                </p>
            );
        }

        return null;
    }
}

const mapStateToProps = (state) => ({
    products: state.catalog && state.catalog.filteredProducts,
    filters: state.catalog && state.catalog.filters,
});

const mapDispatchToProps = (dispatch) => ({
    filter: (payload) => dispatch({ type: 'catalog:filter', payload: payload }),
});

export default connect(mapStateToProps, mapDispatchToProps)(Component);
